import { ReactElement } from "react"
import { PaginationButtonsGroup, PaginationControlsProps } from "../PaginationControls"

export function PaginationControlsMapPage(props: PaginationControlsProps): ReactElement {
	return (
		<div className={`border-dipai-text-disabled border-t-1 pt-3`}>
			<div
				id="map-table-pagination"
				className={`grid h-8 w-full grid-cols-[8rem_1fr_8rem] items-center justify-between gap-4 bg-white`}
			>
				{/* LEFT AREA */}
				<div className="size-8" />
				{/* CENTRAL AREA */}
				<PaginationButtonsGroup {...props} />
				{/* RIGHT AREA */}
				<div className="flex w-full justify-end">
					{/* AMOUNT TO DISPLAY DROPDOWN */}
					<select
						value={props.tableState.pagination.pageSize}
						className="border-dipai-text-muted text-small hover:border-dipai-text-highlight focus:border-dipai-text-highlight text-dipai-text-primary mr-px h-8 w-30 rounded-sm border-1 py-0.5 pr-10 pl-3 hover:cursor-pointer focus:mr-0 focus:w-[calc(7.5rem+0.0625rem)] focus:border-2 focus:pl-[calc(0.75rem-0.0625rem)] focus:ring-0 focus:outline-hidden"
						onChange={(e) => props.setPageSize(Number(e.target.value))}
					>
						{[10, 25, 50].map((pageSize) => (
							<option
								key={pageSize}
								value={pageSize}
							>
								{`${props.translationFunc("SHOW")} ${pageSize}`}
							</option>
						))}
					</select>
				</div>
			</div>
		</div>
	)
}
